import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockList24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconClockList24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.75 12a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0M10 4.25a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5M10.75 8a.75.75 0 0 0-1.5 0v4.75h3.25a.75.75 0 0 0 0-1.5h-1.75zm10.5 2.75h-2.084a9 9 0 0 0-.332-1.5h2.416a.75.75 0 0 1 0 1.5m0-4h-3.633a9.3 9.3 0 0 0-1.292-1.5h4.925a.75.75 0 0 1 0 1.5m-2.084 6.5a9 9 0 0 1-.332 1.5h2.416a.75.75 0 0 0 0-1.5zm-1.55 4a9.3 9.3 0 0 1-1.291 1.5h4.925a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockList24);
